import { createAction } from '@lingoda/core';
import { type MinimalBookingDates } from '../models';

export default createAction(
    'booking/UPDATE_MIN_DATES',
    (minDates: Partial<MinimalBookingDates>) => minDates,
);
